export function getRole(role, canManageMember) {
    if (role === 'member' && canManageMember === true) {
        return 'admin';
    }
    return role;
}
